// Portal-specific translations + helpers
import { useI18n } from "@/contexts/I18nContext";

export const PORTAL_TRANSLATIONS = {
  ar: {
    "portal.title": "Track Your Visa",
    "portal.tagline": "تابع معاملتك بكل سهولة",
    "portal.cta.submit": "تقديم طلب تأشيرة",
    "portal.cta.track": "متابعة معاملة",
    "portal.disabled.title": "البوابة متوقفة مؤقتاً",
    "portal.disabled.body": "البوابة قيد الصيانة حالياً. نعتذر عن الإزعاج.",
    "portal.banner.preview": "وضع المعاينة — هذه نسخة تجريبية للمراجعة من قبل STAS",
    "portal.banner.test": "وضع التجربة — الطلبات هنا تُعتبر اختبارية ولا تُعامل كمعاملات حقيقية",
    "portal.note": "هذه بوابة مخصصة للعملاء فقط — منفصلة تماماً عن النظام الداخلي",
    "portal.placeholder.coming": "محتوى البوابة قيد التطوير. سيتم تفعيل التقديم والتتبع في المرحلة التالية حسب طلبك.",
  },
  en: {
    "portal.title": "Track Your Visa",
    "portal.tagline": "Follow your visa application with ease",
    "portal.cta.submit": "Submit a visa application",
    "portal.cta.track": "Track an application",
    "portal.disabled.title": "Portal temporarily offline",
    "portal.disabled.body": "The portal is currently under maintenance. We apologize for the inconvenience.",
    "portal.banner.preview": "Preview mode — STAS-only preview of the portal",
    "portal.banner.test": "Test mode — submissions here are treated as test data, not real applications",
    "portal.note": "This portal is for clients only — fully separated from the internal system",
    "portal.placeholder.coming": "Portal content is under development. Submission & tracking will be enabled in the next phase per your direction.",
  },
};

// Helper to merge portal strings into the main t() function
export function usePortalT() {
  const { t: baseT, lang } = useI18n();
  return (key, vars) => {
    if (PORTAL_TRANSLATIONS[lang] && PORTAL_TRANSLATIONS[lang][key]) {
      let s = PORTAL_TRANSLATIONS[lang][key];
      if (vars) Object.keys(vars).forEach((k) => { s = s.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]); });
      return s;
    }
    return baseT(key, vars);
  };
}
